/*!jslint
  this
*/
jQuery(function($) {
    "use strict";

    var windowWidth = $(window).width();
    var debounceResize;
    function windowResize(event) {
      if(debounceResize) {
        clearTimeout(debounceResize);
        debounceResize = null;
      }
      debounceResize = setTimeout(function() {
        windowWidth = $(window).width();
      }, 300)
    }
    sliderInit();
    function sliderInit() {
      if($('body').hasClass('home')) {
        $('.custom-products-block .row').each(function(){
          $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            speed: 600,
            infinite: false,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"></button>',
            responsive: [
              {
                breakpoint: 768,
                settings : {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 576,
                settings : {
                            slidesToShow: 1.2,
                        }
              },
              
            ]
          });
        });
      }

      if($('body').hasClass('single-product')) {
        new SimpleBar($('.related.products .wrap-related-products')[0], { autoHide: false });
      }
    }

    $(document).on('click', '.nav-toggle', function(){
      $('.nav-toggle').toggleClass('on');
      $('html').toggleClass('nav-on');
    });


    $(document).on('mouseover', '.main-navigation ul > li', function(e){
      e.stopPropagation();
      $(this).addClass('active');
    });
    var enterMenu = false;
    $('body').on('mouseenter', '.main-navigation .menu li > ul', function (e) {
      enterMenu = true;
    });
    $('body').on('mouseleave', '.main-navigation .menu > li', function (e) {
      enterMenu = false;
      $(this).closest('li').removeClass('active');
    });


    if( windowWidth < 768 ) {
      $('body').on('click', '.menu-primary-menu-container > ul li', function (e) {
        console.log('e', e)
        if (e.target.classList.contains('menu-item')) {
          $(this).addClass('active');
          e.preventDefault();
        }
      });
    }

    $('body').on('mouseleave', '.main-navigation .menu > li', function (e) {
      enterMenu = false;
      $(this).closest('li').removeClass('active');
    });

    $('body').on('click', '.faq-item-header, .acc-item-header', function (e) {
      $(this).toggleClass('active');
    });

    $('.faq-sidebar a').on('click', function (e) {
      if($(this)[0].hash) {
        $($(this)[0].hash).toggleClass('active');
      }
    });


    $('.wpgis-slider-for').slick('slickSetOption', 'verticalSwiping', false);

    
    $('body').on('click', '.woocommerce-review-link', function (e) {
      var reviews = $('#reviews');
      console.log('reviews: ', reviews)
      if(reviews.length) {
        reviews.parents('.acc-item-wrap').find('.acc-item-header').addClass('active');
      }
    });

    


    var showChar = 100;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Read More";
    var lesstext = "Read Less";
    

    $('.more').each(function() {
        var content = $(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
            var html = stripHtml(c) + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<span class="morelink">' + moretext + '</span>';
 
            $(this).html(html);
        }
 
    });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });

    function stripHtml(html){
      return html.replace(/<[^>]*>?/gm, '');
    }
    
    window.addEventListener('resize', windowResize, true);
});